<template>
	<template v-if="company?.id">
		<div class="dropdown-divider"></div>
		<template v-if="['admin', 'leader'].some(valor => company.pivot.roles.includes(valor))">
			<div class="dropdown-header lh-sm">
				<router-link :to="{ name: 'company.admin.home', params: { company_id: company?.id }}" class="link-dark fw-bold text-truncate">{{ company.name }}</router-link>
				<div>Administración</div>
			</div>
			<router-link :to="{ name: 'company.admin.customer.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-briefcase pe-2"></i>Clientes</router-link>
			<router-link :to="{ name: 'company.leader.customer.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('leader')"><i class="bi bi-check-square pe-2"></i>Asignar clientes</router-link>
			<router-link :to="{ name: 'company.admin.sale.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-receipt pe-2"></i>Ventas</router-link>
			<router-link :to="{ name: 'company.admin.user.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-people pe-2"></i>Usuarios</router-link>
			<router-link :to="{ name: 'company.admin.balance.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-coin pe-2"></i>Balances</router-link>
			<router-link :to="{ name: 'company.admin.synchronizer.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-plug pe-2"></i>Conexiones</router-link>
			<router-link :to="{ name: 'company.admin.goal.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-flag pe-2"></i>Metas</router-link>
			<router-link :to="{ name: 'company.admin.report.general' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-graph-up pe-2"></i>Estadísticas</router-link>
			<router-link :to="{ name: 'company.admin.setting.index' }" class="dropdown-item rounded-0" v-if="company.pivot.roles.includes('admin')"><i class="bi bi-building pe-2"></i>Perfil</router-link>
		</template>
	</template>
</template>

<script>
	import { computed } from 'vue';
	import store from '@/store';

	export default {
		setup() {
			const company = computed(() => store.getters['company/info']);

			return { company };
		}
	}
</script>